'use strict';
const codePointForStickerDescriptor = require('./code-point-for-sticker-descriptor');
module.exports = function calculateEmojis(stickers, options) {
	const processVariants = function (codePointArray) {
		if (options && options.ignoreVariants) {
			return [codePointArray[0]];
		}
		return codePointArray;
	};
	return stickers.map(stickerDescriptor => {
		const codepoint = codePointForStickerDescriptor(stickerDescriptor),
			codepointArray = codepoint && codepoint.split(' ').map(x => parseInt(x, 16));
		return codepointArray && String.fromCodePoint.apply(String, processVariants(codepointArray));
	});
};
